<template>
  <div id="login" class="login">
    <van-nav-bar
      class="login-nav"
      title=""
      :z-index="10"
      @click-left="$router.push({ path: '/home' })"
      left-arrow></van-nav-bar>

    <div class="top-area">
      <img src="../../assets/img/share.png" fit="cover" class="top-logo" />
      <div class="top-title fs-20">欢迎来到天安金交中心</div>
    </div>

    <!-- 切换登录方式 -->
    <div class="login-change-bg">
      <van-tabs
        v-model="login_status"
        @click="onTabsClick"
        line-height="5"
        line-width="30%"
        color="rgb(226, 152, 56)"
        title-active-color="rgb(226, 152, 56)">
        <van-tab title="验证码登录"></van-tab>
        <van-tab title="密码登录"></van-tab>
      </van-tabs>
    </div>

    <!--验证码登录-->
    <div class="item-mobile">
      <van-field
        id="tel"
        class="item-field"
        v-model="tempMobile"
        @focus="onFocus"
        @blur="onExistbyphone"
        @input="onChangedInput"
        type="tel"
        maxlength="13"
        clearable
        placeholder="" />
      <!--// 通过mobileChangeIndex的值判断生效那一套样式 -->
      <!--// :class="[{'类名':条件},{'类名':条件}]" -->
      <label
        :class="[
          { focusBlur: mobileChangeIndex == 1 },
          { focusBlurTwo: mobileChangeIndex == 2 }
        ]"
        >请输入手机号</label
      >
    </div>

    <div class="item-password">
      <div v-if="login_status == 1">
        <van-field
          v-model="loginForm.field.loginCode"
          @focus="onPasswordFocus"
          @blur="onPasswordBlur"
          type="password"
          maxlength="18"
          clearable>
        </van-field>
        <!--// 通过mobileChangeIndex的值判断生效那一套样式 -->
        <!--// :class="[{'类名':条件},{'类名':条件}]" -->
        <label
          :class="[
            { focusBlur: passwordChangeIndex == 1 },
            { focusBlurTwo: passwordChangeIndex == 2 }
          ]"
          >请输入登录密码</label
        >
      </div>
      <div v-else-if="login_status == 0">
        <van-field
          v-model="loginForm.field.loginCode"
          @focus="onPasswordFocus"
          @blur="onPasswordBlur"
          type="number"
          maxlength="6"
          clearable>
          <van-button
            class="sms-code-btn"
            :loading="smsForm.loading"
            loading-text="发送中..."
            @click="onSMSSend"
            plain
            :disabled="isSendSMSEnable"
            slot="button"
            size="small"
            type="danger"
            >{{ getSendBtnText }}</van-button
          >
        </van-field>
        <!--// 通过mobileChangeIndex的值判断生效那一套样式 -->
        <!--// :class="[{'类名':条件},{'类名':条件}]" -->
        <label
          :class="[
            { focusBlur: passwordChangeIndex == 1 },
            { focusBlurTwo: passwordChangeIndex == 2 }
          ]"
          >请输入6位验证码</label
        >
      </div>
    </div>
    <div
      v-if="loginForm.showReferrerCode"
      class="item-invite"
      style="margin-top: 10px">
      <van-field
        v-model="loginForm.field.referrerCode"
        clearable
        readonly
        type="number"
        maxlength="11"
        input-align="right"
        label="填写邀请人"
        placeholder="请输入邀请人手机号/账户ID(选填)"
        @click="onSelectInviter" />
      <van-field style="height: 0" />
    </div>

    <van-cell class="home-footer">
      <div class="read-and-agree-box" style="margin-top: 10px">
        <van-checkbox
          class="read-and-agree"
          v-model="consent_agreement"
          shape="round"
          checked-color="rgb(226, 152, 56)">
          <div class="read-text">
            <div class="rar-1">阅读并同意</div>
            <div @click.stop="showAgreement">
              《天安金交中心服务协议-个人会员版》
            </div>
          </div>
        </van-checkbox>
      </div>
      <van-button
        class="confirm-login fs-18"
        type="default"
        size="large"
        @click="onSMSLogin"
        >登录</van-button
      >
      <template v-if="isShowForget">
        <div class="bottom-button">
          <div class="left-btn">
            <template v-if="login_status == 0">
              <span class="left-span">收不到验证码？试试</span>
              <span @click="login_status = 1">&nbsp;密码登录</span>
            </template>
            <template v-else>
              <span @click="onForgetPwd">忘记密码？</span>
            </template>
          </div>
          <div class="right-btn" @click="onRegisterUser">新用户注册</div>
        </div>
      </template>
    </van-cell>
    <!-- <div class="wechat-auth-login-bg">
      <div class="item-bg" @click="onWechatLogin">
        <img src="../../assets/img/register/share_WeChat.png" />
        <div>绑定登录</div>
      </div>
      <div class="item-bg" @click="onWechatALogin">
        <img src="../../assets/img/register/share_WeChat.png" />
        <div>微信一键登录</div>
      </div>
    </div> -->
    <!-- 添加图片滑动解锁 -->
    <PhotoSlide
      ref="slideblock"
      @success="onSlideSuccess"
      sliderText="向右滑"
      :show="false"
      :showSlidePop.sync="showSlidePop"></PhotoSlide>
  </div>
</template>

<script>
import {
  Checkbox,
  Button,
  Field,
  Image,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  Popup,
  Toast,
  Dialog,
  Overlay,
  Tabs,
  Tab
} from "vant"

import * as CustApi from "@/api/cust"
import * as PayApi from "@/api/pay"
import storage from "@/utils/storage"
import { mapActions, mapGetters, mapMutations } from "vuex"
import PhotoSlide from "../../components/photoSlide.vue"
import { authorize } from "../../assets/js/authorize"
import * as LuanchApi from "@/api/luanch"
import session from "../../utils/session"
import { loadSeven } from "../../api/lottery"

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Overlay.name]: Overlay,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    PhotoSlide
  },

  data() {
    return {
      login_status: 0, //登录状态：0 验证码登录 1 密码登陆（默认0）
      consent_agreement: false, // 阅读并同意相关协议
      services_agreement: false, // 服务协议
      privacy_agreement: false, // 隐私协议
      agreement_title: "",
      agreement_content: "",
      tel_length: 0,
      isShowForget: true,
      showSlidePop: false, // 是否显示滑块解锁框
      mobileChangeIndex: 0, //手机号定义一个变量;0默认样式，1第二套样式，2第三套样式
      passwordChangeIndex: 0, //密码/验证码定义一个变量;0默认样式，1第二套样式，2第三套样式
      smsForm: {
        loading: false,
        smsCountDown: 0,
        smsInterval: null
      },
      tempMobile: "",
      loginForm: {
        loading: false,
        showReferrerCode: false,
        field: {
          referrerCust: "",
          mobile: "",
          loginCode: "",
          referrerCode: "",
          loginType: "VLTC", //验证码登录：VLTC 密码登录：PLTC
          referrerChanl: "",
          referrerType: "", // 处理积分商城入口登录

          productId: "",
          parentId: ""
        }
      },
      sectionId: "", // 临时缓存
      advInterval: null, // 开屏广告倒计时
      advCountDown: 0
    }
  },
  watch: {
    showLuanch: function (val, old) {
      if (!val) {
        if (this.advInterval) {
          clearInterval(this.advInterval)
          this.getRedirectUri(this.userInfo)
          // this.openLoadSeven()
        }
      }
    },
    login_status: function (val, old) {
      if (val != old) {
        this.loginForm.field.loginCode = ""
      }
      if (val == 0) {
        this.loginForm.field.loginType = "VLTC"
      } else if (val == 1) {
        this.loginForm.field.loginType = "PLTC"
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo", "channel", "deviceToken", "showLuanch"]),
    isSendSMSEnable() {
      return this.smsForm.smsCountDown !== 0
    },
    getSendBtnText() {
      if (this.smsForm.smsCountDown > 0) {
        return this.smsForm.smsCountDown
      } else {
        return "获取验证码"
      }
    }
  },

  beforeDestroy() {
    if (this.smsForm.smsInterval) {
      clearInterval(this.smsForm.smsInterval)
    }
    if (this.advInterval) {
      clearInterval(this.advInterval)
    }
    window.removeEventListener("devicemotion", this.devicemotion)
    window.removeEventListener("shake", this.devicemotion)
  },

  beforeMount() {
    this.loginForm.field.referrerCust = this.$route.query.invite || ""

    if (localStorage.getItem("MallEnterKey")) {
      this.loginForm.field.referrerType = localStorage.getItem("MallEnterKey")
    }

    let user_info = storage.getJson("user-info")
    if (user_info && user_info.loginType === "FLTC") {
      this.$router.push({ path: "/gesture", query: this.$route.query })
    }

    this.loginForm.field.referrerCode = this.$route.query.referrerCode || ""
    this.loginForm.field.referrerChanl = this.$route.query.referrerChanl || ""
    this.consent_agreement = !!this.$store.state.login.userAgreementLogin
    this.$store.state.login.userAgreementLogin = ""

    this.getFormCache()
    let mobile = this.getRealMobile()
    if (mobile != "") {
      this.mobileChangeIndex = 2 //如果框中有值,展示第三套样式
    } else if (mobile == "") {
      this.mobileChangeIndex = 0 //失焦等于 0,展示默认样式
    }
    this.onPasswordBlur()

    console.log("login this.$route.query == %O", this.$route.query)
    if (
      this.$route.query.productId &&
      this.$route.query.referrerCod &&
      this.$route.query.referrerType
    ) {
      // this.isShowForget = false

      this.loginForm.field.referrerCode = this.$route.query.referrerCod
      this.loginForm.field.parentId = this.$route.query.referrerCod
      this.loginForm.field.referrerCust = this.$route.query.referrerType
      this.loginForm.field.productId = this.$route.query.productId
    } else if (
      this.$route.query.sectionId &&
      this.$route.query.referrerCod &&
      this.$route.query.referrerType
    ) {
      // this.isShowForget = false

      this.loginForm.field.referrerCode = this.$route.query.referrerCod
      this.loginForm.field.parentId = this.$route.query.referrerCod
      this.loginForm.field.referrerCust = this.$route.query.referrerType
      this.loginForm.field.productId = this.$route.query.sectionId
      this.sectionId = this.$route.query.sectionId
    }
  },

  methods: {
    devicemotion() {},
    // 切换登录方式
    onTabsClick(name, title) {
      console.log(name, title)
      this.login_status = name

      if (this.login_status == 0) {
        this.loginForm.field.loginType = "VLTC"
      } else if (this.login_status == 1) {
        this.loginForm.field.loginType = "PLTC"
      }
    },
    // 防止键盘弹出后，页面上移后，隐藏键盘页面无法回到原位置问题
    onKeyboardScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      console.log("scrollTop == %O", scrollTop)
      if (scrollTop > 0) {
        setTimeout(() => {
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
        }, 500)
      }
    },
    // 获取焦点事件
    onFocus() {
      //获取焦点等于1，展示第二套样式，文字提示平移到input框上面
      this.mobileChangeIndex = 1
    },
    /**
     * 失焦事件，通过手机号判断用户是否存在
     * @response 手机号已注册过返回 true , 未注册过的手机号返回 false
     *
     */
    onExistbyphone() {
      let mobile = this.getRealMobile()
      if (mobile != "") {
        this.mobileChangeIndex = 2 //如果框中有值,展示第三套样式
      } else if (mobile == "") {
        this.mobileChangeIndex = 0 //失焦等于 0,展示默认样式
      }
      if (mobile.length < 11 || !/^\d+$/.test(mobile)) return

      // if (!this.$route.query.referrerType) {
      this.loginForm.field.loginCode = ""
      CustApi.existbyphone({ phone: mobile })
        .then((data) => {
          this.loginForm.showReferrerCode = !data || false
        })
        .catch((e) => {
          this.loginForm.showReferrerCode = false
        })
      // } else {
      //   this.loginForm.showReferrerCode = false
      // }
    },

    // 手机号输入框信息改变时处理，手机号中间加空格
    onChangedInput() {
      if (this.tempMobile.length > this.tel_length) {
        //输入
        if (this.tempMobile.length == 4 || this.tempMobile.length == 9) {
          let str = this.tempMobile.substring(0, this.tempMobile.length - 1)
          str =
            str +
            " " +
            this.tempMobile.substring(
              this.tempMobile.length - 1,
              this.tempMobile.length
            )
          this.tempMobile = str
        } else if (this.tempMobile.length >= 13) {
          this.tempMobile = this.tempMobile.substring(0, 13)
        }
        this.tel_length = this.tempMobile.length
      } else if (this.tempMobile.length < this.tel_length) {
        //删除
        if (this.tempMobile.length == 4 || this.tempMobile.length == 9) {
          this.tempMobile = this.tempMobile.substring(
            0,
            this.tempMobile.length - 1
          )
        }
        this.tel_length = this.tempMobile.length
      }
    },
    // 获取真实的手机号，去掉手机号中的空格
    getRealMobile() {
      if (this.tempMobile) {
        let list = this.tempMobile.split(" ")
        let mobile = list.join("")
        return mobile
      }
      return ""
    },
    onForgetPwd() {
      this.setFormCache()
      session.setJson("RegisterAndForgetPwdKey", {
        type: 1,
        mobile: this.getRealMobile()
      })
      this.$router.push({
        name: "personalCenter-loginpwd1"
      })
    },
    // 注册用户
    onRegisterUser() {
      this.setFormCache()
      session.setJson("RegisterAndForgetPwdKey", {
        type: 2,
        mobile: this.getRealMobile()
      })
      this.$router.push({
        name: "personalCenter-loginpwd1"
      })
    },
    // 页面跳转缓存手机号
    setFormCache() {
      storage.set("__login_mobile", this.tempMobile)
      storage.set("__login_loginCode", this.loginForm.field.loginCode)
      storage.set("__login_type", this.login_status)
    },
    // 点击 `服务协议后` 缓存数据的逻辑
    getFormCache() {
      let __login_mobile = storage.get("__login_mobile")
      let __login_loginCode = storage.get("__login_loginCode")
      this.login_status = parseInt(storage.get("__login_type")) || 0

      storage.del("__login_type")

      if (__login_mobile) {
        this.tempMobile = __login_mobile
        this.tel_length = __login_mobile.length
        storage.del("__login_mobile")
        this.onExistbyphone()
      } else {
        this.tempMobile = localStorage.getItem("user-account")
      }
      if (__login_loginCode) {
        this.loginForm.field.loginCode = __login_loginCode
        storage.del("__login_loginCode")
      }
    },

    onPasswordFocus() {
      this.passwordChangeIndex = 1
    },
    onPasswordBlur() {
      if (this.loginForm.field.loginCode != "") {
        this.passwordChangeIndex = 2 //如果框中有值,展示第三套样式
      } else if (this.loginForm.field.loginCode == "") {
        this.passwordChangeIndex = 0 //失焦等于 0,展示默认样式
      }
    },

    // 查看服务协议
    showAgreement() {
      this.setFormCache()
      this.$store.state.login.userAgreementLogin = this.consent_agreement
      this.$router.push({ name: "agreement-reg" })
    },

    onSMSSend() {
      let mobile = this.getRealMobile()
      if (mobile.length < 11) {
        Toast("请输入正确的手机号")
        return
      }
      if (!/^\d+$/.test(mobile)) {
        Toast("请输入正确的手机号")
        return
      }
      this.showSlidePop = true
    },
    //滑块验证方法
    onSlideSuccess() {
      this.showSlidePop = false
      this.onSendCode()
    },
    //请求验证码接口
    onSendCode() {
      this.smsForm.loading = true
      this.$refs.slideblock.reset()
      CustApi.sendcode(this.getRealMobile())
        .then((data) => {
          this.smsForm.loading = false
          this.startSMSTimer()
        })
        .catch((e) => {
          this.smsForm.loading = false
          Toast(e.msg || e.message)
        })
    },

    startSMSTimer() {
      this.smsForm.smsCountDown = 60
      this.smsForm.smsInterval = setInterval(() => {
        this.smsForm.smsCountDown--
        if (this.smsForm.smsCountDown <= 0) {
          clearInterval(this.smsForm.smsInterval)
        }
      }, 1000)
    },

    // 表单验证
    getFormVerify() {
      let { loginCode } = this.loginForm.field
      let mobile = this.getRealMobile()
      if (!this.consent_agreement) return "请阅读并同意协议！"
      if (mobile.length < 11) return "请输入正确的手机号"
      if (!/^\d+$/.test(mobile)) return "请输入正确的手机号"
      if (this.login_status == 0) {
        if (loginCode.length < 6) return "请输入正确的验证码"
        if (!/^\d+$/.test(loginCode)) return "请输入正确的验证码"
      } else {
        if (loginCode.length < 6) return "请输入6到18位登录密码"
      }
    },

    onSMSLogin() {
      if (this.getFormVerify()) {
        Toast(this.getFormVerify())
        return
      }
      this._showLoading()
      this.loginForm.field.referrerCode =
        this.loginForm.field.referrerCode.toLocaleUpperCase()
      this.loginForm.field.mobile = this.getRealMobile()

      localStorage.setItem("user-account", this.tempMobile)
      if (this.loginForm.field.productId.length > 0) {
        this.onProductLogin()
      } else {
        this.onLogin()
      }
    },
    onLogin() {
      if (!this.loginForm.showReferrerCode) {
        this.loginForm.field.referrerCode = ""
      }
      CustApi.login(this.loginForm.field)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          localStorage.removeItem("MallEnterKey")
          this.setToken(data)
          this.onGetUserInfo()
        })
        .catch((e) => {
          this._dismissLoading()
          if (e.code == "1011") {
            //用户不存在
            Dialog.alert({
              title: "温馨提示",
              message: "您还没有注册账号，请先去注册？",
              confirmButtonText: "去注册",
              showCancelButton: true,
              theme: "round-button"
            })
              .then(() => {
                this.$router.push({
                  name: "register",
                  query: { mobile: this.getRealMobile() }
                })
              })
              .catch(() => {})
          } else if (e.code == "1012") {
            localStorage.removeItem("MallEnterKey")
            //登录密码未设置
            Dialog.alert({
              title: "温馨提示",
              message: "登录密码尚未设置，请先设置登录密码！",
              confirmButtonText: "去设置",
              showCancelButton: true,
              theme: "round-button"
            })
              .then(() => {
                this.setFormCache()
                session.setJson("RegisterAndForgetPwdKey", {
                  type: 3,
                  mobile: this.getRealMobile()
                })
                this.$router.push({
                  name: "personalCenter-loginpwd1"
                })
              })
              .catch(() => {})
          } else {
            Toast(e.msg || e.message)
          }
        })
    },
    onProductLogin() {
      CustApi.productLogin(this.loginForm.field)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          this.setToken(data)
          this.onGetUserInfo()
        })
        .catch((e) => {
          this._dismissLoading()
          if (e.code == "1011") {
            //用户不存在
            Dialog.alert({
              title: "温馨提示",
              message: "您还没有注册账号，请先去注册？",
              confirmButtonText: "去注册",
              showCancelButton: true,
              theme: "round-button"
            })
              .then(() => {
                this.$router.push({
                  name: "register",
                  query: { mobile: this.getRealMobile() }
                })
              })
              .catch(() => {})
          } else if (e.code == "1012") {
            //登录密码未设置
            Dialog.alert({
              title: "温馨提示",
              message: "登录密码尚未设置，请先设置登录密码！",
              confirmButtonText: "去设置",
              showCancelButton: true,
              theme: "round-button"
            })
              .then(() => {
                this.setFormCache()
                session.setJson("RegisterAndForgetPwdKey", {
                  type: 3,
                  mobile: this.getRealMobile()
                })
                this.$router.push({
                  name: "personalCenter-loginpwd1"
                })
              })
              .catch(() => {})
          } else {
            Toast(e.msg || e.message)
          }
        })
    },

    onGetUserInfo() {
      this.getUserInfo()
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          this.setUserInfo(data)
          PayApi.paytype({ chanlCode: this.channel })
            .then((data) => {
              this.setPayType(data)
            })
            .catch((e) => {
              Toast("获取离线支付方式异常")
            })
          storage.setJson(
            "cache-info",
            Object.assign({}, data, {
              mobile: this.getRealMobile()
            })
          )
          // if (this.isWechant() && process.env.NODE_ENV == "production") {
          if (this.isWechant() && !data.wxAuth) {
            //只能在微信浏览器中才执行
            //process.env.NODE_ENV != "production
            this.openLuanch(true, data)
          } else {
            this.loginSuccessHandle(data)
            this.openLuanch(false, data)
          }
          // this.loginSuccessHandle(data)
          // this.openLuanch(false)
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },
    /**
     * 判断是否有开屏广告
     * @param {*} isWechatAuth 是否微信授权
     * @param {*} userInfo 用户信息
     */
    openLuanch(isWechatAuth, userInfo) {
      LuanchApi.loadAd()
        .then((data) => {
          if (data) {
            this.setShowLuanch(true)
            if (isWechatAuth) {
              this.advCountDown = data["adSeconds"]
              this.startAdvTimer(userInfo)
            }
          } else {
            if (isWechatAuth) {
              this.getRedirectUri(userInfo)
            }
            this.openLoadSeven()
          }
        })
        .catch((e) => {
          console.log("login.vue message == %O", e.msg || e.message)
          if (isWechatAuth) {
            this.getRedirectUri(userInfo)
          }
          this.openLoadSeven()
        })
    },
    startAdvTimer(userInfo) {
      this.advInterval = setInterval(() => {
        this.advCountDown--
        if (this.advCountDown <= 0) {
          clearInterval(this.advInterval)
          this.getRedirectUri(userInfo)
          this.openLoadSeven()
        }
      }, 1000)
    },
    openLoadSeven() {
      loadSeven(0)
        .then((data) => {
          if (data) {
            localStorage.setItem(
              "ignoreCustKey",
              JSON.stringify({
                isBannerJump: false,
                ignore: 0
              })
            )
            this.$router.push({ name: "anniversarycelebration" })
          }
        })
        .catch((e) => {
          console.log("message == %O", e.msg || e.message)
        })
    },
    ...mapMutations([
      "setToken",
      "setChannel",
      "setUserInfo",
      "setPayType",
      "setShowLuanch"
    ]),
    getRedirectUri(data) {
      localStorage.setItem("wechat_auth_status", "phoneAndWechatBindLogin")
      if (this.$route.query.productId) {
        localStorage.setItem("loginSuccess", "loginSuccess")
        CustApi.customizedProductPreach(this.loginForm.field.productId)
          .then((data) => {
            if (data) {
              console.log("data == %O", data)
              if (data.showDetail) {
                //share showDetail
                authorize(
                  location.href.split("#")[0] +
                    "#/detail/productdesc?productId=" +
                    this.loginForm.field.productId
                )
              } else {
                let chanlCode =
                  this.$route.query.chanlCode ||
                  this.$route.params.channel ||
                  "TA"
                authorize(
                  location.href.split("#")[0] + "#/home?chanlCode=" + chanlCode
                )
              }
            } else {
              let chanlCode =
                this.$route.query.chanlCode ||
                this.$route.params.channel ||
                "TA"
              authorize(
                location.href.split("#")[0] + "#/home?chanlCode=" + chanlCode
              )
            }
          })
          .catch((e) => {
            Toast(e.msg || e.message)
          })
      } else if (this.$route.query.sectionId) {
        localStorage.setItem("loginSuccess", "loginSuccess")
        CustApi.sectionProductPreach(this.$route.query.sectionId)
          .then((data) => {
            if (data) {
              console.log("data == %O", data)
              if (data.showList) {
                //share showList
                authorize(
                  location.href.split("#")[0] +
                    "#/myexclusive/companydesc?sectionId=" +
                    this.$route.query.sectionId
                )
              } else {
                let chanlCode =
                  this.$route.query.chanlCode ||
                  this.$route.params.channel ||
                  "TA"
                authorize(
                  location.href.split("#")[0] + "#/home?chanlCode=" + chanlCode
                )
              }
            } else {
              let chanlCode =
                this.$route.query.chanlCode ||
                this.$route.params.channel ||
                "TA"
              authorize(
                location.href.split("#")[0] + "#/home?chanlCode=" + chanlCode
              )
            }
          })
          .catch((e) => {
            Toast(e.msg || e.message)
          })
      } else if (this.loginForm.field.referrerType.length > 0) {
        localStorage.setItem("loginSuccess", "loginSuccess")
        // this.$router.replace({ name: "integralMall" })
        this.$router.push({ path: this.$route.query.redirect })
      } else {
        let appForgetPassword = storage.get("app-forget-password") // 是从 `忘记密码` 的入口前往了登录页
        console.log("data == %O", data)
        console.log("appForgetPassword == %O", appForgetPassword)
        if (appForgetPassword) {
          authorize(location.href.split("#")[0] + "#/gesture")
        }
        if (!data.loginType) {
          authorize(
            location.href.split("#")[0] + "#/gesture?" + this.$route.query
          )
        } else if (this.userInfo.isNew && this.userInfo.isProm === 0) {
          let chanlCode =
            this.$route.query.chanlCode || this.$route.params.channel || "TA"
          authorize(
            location.href.split("#")[0] + "#/home?chanlCode=" + chanlCode
          )
        } else if (this.$route.query && this.$route.query.redirect) {
          authorize(
            location.href.split("#")[0] + "#" + this.$route.query.redirect
          )
        } else {
          localStorage.setItem("loginSuccess", "loginSuccess")
          let chanlCode =
            this.$route.query.chanlCode || this.$route.params.channel || "TA"
          authorize(
            location.href.split("#")[0] + "#/home?chanlCode=" + chanlCode
          )
        }
      }
    },
    loginSuccessHandle(data) {
      if (this.$route.query.productId) {
        localStorage.setItem("loginSuccess", "loginSuccess")
        CustApi.customizedProductPreach(this.loginForm.field.productId)
          .then((data) => {
            if (data) {
              console.log("data == %O", data)
              if (data.showDetail) {
                //share showDetail
                this.$router.push({
                  name: "detail-productdesc",
                  query: { productId: this.loginForm.field.productId }
                })
              } else {
                let chanlCode =
                  this.$route.query.chanlCode || this.$route.params.channel
                return this.$router.push({
                  path: "/home",
                  query: { chanlCode }
                })
              }
            } else {
              let chanlCode =
                this.$route.query.chanlCode || this.$route.params.channel
              return this.$router.push({
                path: "/home",
                query: { chanlCode }
              })
            }
          })
          .catch((e) => {
            Toast(e.msg || e.message)
          })
      } else if (this.$route.query.sectionId) {
        localStorage.setItem("loginSuccess", "loginSuccess")
        CustApi.sectionProductPreach(this.$route.query.sectionId)
          .then((data) => {
            if (data) {
              console.log("data == %O", data)
              if (data.showList) {
                //share showList
                this.$router.push({
                  name: "myexclusive-companydesc",
                  query: {
                    sectionId: this.$route.query.sectionId
                  }
                })
              } else {
                let chanlCode =
                  this.$route.query.chanlCode || this.$route.params.channel
                return this.$router.push({
                  path: "/home",
                  query: { chanlCode }
                })
              }
            } else {
              let chanlCode =
                this.$route.query.chanlCode || this.$route.params.channel
              return this.$router.push({
                path: "/home",
                query: { chanlCode }
              })
            }
          })
          .catch((e) => {
            Toast(e.msg || e.message)
          })
      } else if (this.loginForm.field.referrerType.length > 0) {
        localStorage.setItem("loginSuccess", "loginSuccess")
        return this.$router.push({ path: this.$route.query.redirect })
        // return this.$router.replace({ name: "integralMall" })
      } else {
        let appForgetPassword = storage.get("app-forget-password") // 是从 `忘记密码` 的入口前往了登录页
        console.log("appForgetPassword == %O", appForgetPassword)
        if (appForgetPassword) {
          this.$router.push({ path: "/gesture" })
          return
        }
        if (!data.loginType) {
          return this.$router.push({
            path: "/gesture",
            query: this.$route.query
          })
        } else if (this.userInfo.isNew && this.userInfo.isProm === 0) {
          let chanlCode =
            this.$route.query.chanlCode || this.$route.params.channel
          return this.$router.push({
            path: "/home",
            query: { chanlCode }
          })
        } else if (this.$route.query && this.$route.query.redirect) {
          return this.$router.replace({ path: this.$route.query.redirect })
          // location.href = `${location.href.split("#")[0]}#${
          //   this.$route.query.redirect
          // }`
          // return location.href
        } else {
          localStorage.setItem("loginSuccess", "loginSuccess")
          let chanlCode =
            this.$route.query.chanlCode || this.$route.params.channel
          return this.$router.push({
            path: "/home",
            query: { chanlCode }
          })
        }
      }
    },
    onWechatLogin() {
      authorize(
        location.href.split("#")[0] + "#/login/wechatAuthLogin?chanlCode=TA"
      )
    },
    onWechatALogin() {
      authorize(location.href.split("#")[0] + "#/home?loginType=AKeyLogin")
    },
    onSelectInviter() {
      this.setFormCache()
      this.$router.push({ name: "search_inviter" })
    },
    ...mapActions(["getUserInfo"])
  }
}
</script>

<style lang="less" scoped>
@import "./idx.less";
.wechat-auth-login-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 15px;
  .item-bg {
    background-color: #e29838;
    border-radius: 50px;
    padding: 5px 30px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    color: white;
    img {
      padding-right: 5px;
      width: 40px;
      height: 40px;
    }
  }
}
.item-invite {
  // border: #e29838 1px solid;
  .van-cell {
    // border: #e29838 1px solid;
    ::v-deep .van-cell__title {
      font-size: 14px;
    }
    ::v-deep .van-cell__value {
      font-size: 14px;
    }
    &::after {
      // display: none;
      border-bottom: 0.02667rem solid #ebedf0;
    }
  }
}
</style>
